+$(function ($) {
  'use strict';

  var body = $('body');
  body.on('click', '.policies-list__item', function (e) {
    e.preventDefault();
    var show_tab = $(this).attr('data-policy-tab');
    $('[data-policy-switch-tab]').hide();
    $('[data-policy-switch-tab="' + show_tab + '"]').show();
  });
  $('#open-modal, .open-modal, #open-book-modal').click(function () {
    $('.modal').css('display', 'block');
    $('body').addClass('modal-open');
    $('.packages-modal, .book-table-modal').css('display', 'none');
  });
  $('#close-modal, .close-packages-modal, #close-book-table-modal').click(function () {
    $('.modal, .packages-modal, .book-table-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });
  $('#booking-modal, #packages-modal, #book-table-modal, #form-success, #success-contact-modal, #success-carrers-modal, #home-modal, #success-payment-modal, #popup-added-to-cart').click(function (event) {
    if ($(event.target).is('#booking-modal, #book-table-modal, #form-success, #packages-modal, #success-contact-modal, #success-carrers-modal, #home-modal, #success-payment-modal, .bg-filter')) {
      $('.modal, .book-table-modal, .packages-modal, .success-contact-modal, .success-carrers-modal, .home-modal, .success-payment-modal, .popup').css('display', 'none');
      $('body').removeClass('modal-open');
    }
  });
  $('.language').click(function () {
    $(this).addClass('dot').siblings().removeClass('dot');
  });
  $('.white-header_language').click(function () {
    $(this).addClass('white-header_dot').siblings().removeClass(' white-header_dot');
  });
  $('#open-menu, .open-menu, .close-menu-modal').click(function () {
    // $('.menu-modal').css('display', 'block')
    $('.menu-modal').toggle();
  });
  $('.open-packages-modal, .open-packages-modal').click(function () {
    $('.packages-modal').css('display', 'block');
    $('.modal, .book-table-modal').css('display', 'none');
    $('body').addClass('modal-open');
  });
  $('#open-book-table-modal, .open-book-table-modal').click(function () {
    $('.book-table-modal').css('display', 'block');
    $('.modal, .packages-modal').css('display', 'none');
    $('body').addClass('modal-open');
  });
  $('#close-menu, #close-menu-modal').click(function () {
    $('.menu-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });
  $('#close-success-contact-modal').click(function () {
    $('.success-contact-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });
  $('#close-success-carrers-modal').click(function () {
    $('.success-carrers-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });
  $('#close-success-payment-modal').click(function () {
    $('.success-payment-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });
  $('#close-home-modal').click(function () {
    $('.home-modal').css('display', 'none');
    $('body').removeClass('modal-open');
  });

  if ($(window).width() <= 1340) {
    var addLinkClone = $('.additional_menu_item');
    addLinkClone.each(function () {
      $(this).removeClass('additional_menu_item').removeClass('menu-list__items--list');
      $(this).addClass('menu-list').addClass('menu-list__title');
      $('.menu').append($(this).clone());
      $(this).remove();
    });
  }

  body.on('click', '.js-data-link', function (e) {
    e.preventDefault();
    window.location = $(this).attr('data-link-to');
  }); //search

  body.on('click', '.search.load-more', function (e) {
    e.preventDefault();
    var button = $(this);
    var offset = parseInt(button.attr('data-offset'));
    var per_page = parseInt(button.attr('data-per-page'));
    var search = button.attr('data-search');
    var total = parseInt(button.attr('data-total'));
    var next_offset = offset + parseInt(per_page);
    var loader = button.find('.more-loader');
    var loader_content = button.find('.load-content');
    loader.toggle();
    loader_content.toggle();
    $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'load_more_search_results',
        offset: offset,
        search: search
      },
      success: function success(data) {
        $('.results-container').append(data.html);
        button.attr('data-offset', next_offset);

        if (next_offset > total) {
          button.hide();
        }

        loader.toggle();
        loader_content.toggle();
      }
    });
    return false;
  }); //eof search
  // carousel

  $(document).ready(function () {
    $('.menu-modal__img').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('show');
      $(this).prev('.sub-menu').slideToggle().toggleClass('visible');
      $(this).find('.plus-minus').toggle();
    });
    $('.close').click(function () {
      $(this).prev().toggle();
      $(this).toggle();
      $(this).prev('.sub-menu').slideToggle().toggleClass('visible');
    });
    $('.conference-blocks').on('click', function (e) {
      // e.preventDefault();
      $(this).toggleClass('show, conference-description-toggle');
      $(this).find('.conference-description').toggleClass("toggle-border"); // $(this).toggleClass('show')

      $(this).find('.conference-description-responsive-open').slideToggle().toggleClass('visible');
      $(this).next('.conference-description__open').slideToggle().toggleClass('visible');
      $(this).find('.open-conference-img').toggle();
      initializeConferenceSlider($(this).closest('.conference-block-row').find('.main-slider'));
    }); //room policies

    $('.policies-list__item').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active-policies');
      $(this).siblings().removeClass('active-policies'); // $(this).prev('.sub-menu').slideToggle().toggleClass('visible')
      // $(this).find('.plus-minus').toggle()
    }); // close cookies

    $('#accept-cookies').click(function () {
      $('#cookies').css('display', 'none');
    });
    $('.js-custom-form').each(function () {
      var names = "";
      $('[id^="field-"]').each(function () {
        names += $(this).attr('name') + " ";
      });
      names = $.trim(names);
      $(this).validate({
        // errorContainer: '.main-form-errors',
        // errorLabelContainer: '.main-form-errors ul',
        errorContainer: $(this).find('.main-form-errors'),
        errorLabelContainer: $('ul', $(this).find('.main-form-errors')),
        wrapper: 'li',
        ignore: [],
        groups: {
          mygroup: names
        },
        submitHandler: function submitHandler(form) {
          var success_title = $(this).data('success-title');
          var $success_popup = $('#form-success');
          $success_popup.find('.success-message').html(success_title);
          var formData = new FormData($(form)[0]);
          var gaCategory = $(form).find('input[name="analyitics-category"]');
          var gaLabel = $(form).find('input[name="analyitics-label"]');
          $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            async: false,
            cache: false,
            contentType: false,
            enctype: 'multipart/form-data',
            processData: false,
            success: function success(response) {
              $('.js-custom-form').trigger('reset');

              if (response.ok == 1) {
                $success_popup.css('display', 'block');
                $('body').addClass('modal-open');

                if (gaCategory.length && gaLabel.length) {
                  gaCategory = gaCategory.val();
                  gaLabel = gaLabel.val();
                  gtag('event', 'click', {
                    'event_category': gaCategory,
                    'event_label': gaLabel
                  });
                }
              }
            }
          });
          return false;
        }
      });
    });
    $('.js-form-select-button').click(function (event) {
      $('.form-wrapper').css('display', 'none');
      $('#' + $(this).val()).fadeIn();
    });
    $('#billing').validate({
      errorContainer: $(this).find('.billing-form-errors'),
      errorLabelContainer: $('ul', $(this).find('.billing-form-errors')),
      wrapper: 'li',
      groups: {
        mygroup: 'name email phone country address town zip'
      },
      submitHandler: function submitHandler(form) {
        $('.billing-details').css('display', 'none');
        $('.cart').css('display', 'none');
        $('.overview-page').css('display', 'none');
        $('.paysera-payment-method').css('display', 'block');
        $(this).addClass('current').siblings().removeClass('current');
        $('.payment-block').addClass('current').siblings().removeClass('current');
        form.submit();
      }
    });
    $('#payment').validate({
      errorContainer: $(this).find('.payment-form-errors'),
      errorLabelContainer: $('ul', $(this).find('.payment-form-errors')),
      wrapper: 'li',
      groups: {
        mygroup: 'payment[] checkbox1'
      },
      submitHandler: function submitHandler(form) {
        $('.billing-details').css('display', 'none');
        $('.cart').css('display', 'none');
        $('.paysera-payment-method').css('display', 'none');
        $('.overview-page').css('display', 'block');
        $(this).addClass('current').siblings().removeClass('current');
        $('.overview-block-button').addClass('current').siblings().removeClass('current'); // form.submit()
      }
    });
    $('#overview').validate({
      submitHandler: function submitHandler(form) {
        $('.success-payment-modal').css('display', 'block');
        $('body').addClass('modal-open'); // form.submit()
      }
    });
    $.extend($.validator.messages, {
      required: 'Please, fill all required fields!'
    });
    $('input').on('change', function () {
      $(this).trigger('blur');
    });
    $('.payment-logo__item').click(function () {
      $(this).css('border', '1px solid #222123').siblings().css('border', '1px solid #DBDBDB');
    });
    $('.gift-cards__img').click(function (e) {
      e.preventDefault();
      $(this).addClass('selected').siblings().removeClass('selected');
    }); // body.on('click', '.gift-cards__img', function (e) {
    //   e.preventDefault()
    // })

    $('.gift-card__amount').click(function () {
      $('.gift-card__amount').removeClass('selected');
      $('.gift-input').removeClass('selected').val('');
      var button = $(this);
      var price = button.attr('data-price');
      button.addClass('selected');
      changeGiftCardPrice(price);
    });
    body.on('change', '.gift-input', function (e) {
      $(this).addClass('selected');
      $('.gift-card__amount').removeClass('selected');
      var value = $(this).val();
      changeGiftCardPrice(value);
    });

    function changeGiftCardPrice(price) {
      var parse_price = parseFloat(price).toFixed(2);

      if (parse_price < 30) {
        parse_price = parseFloat(30).toFixed(2);
        $('.gift-input').val(parse_price);
      }

      $('.gift-card-price').html(parse_price.toString().replace(/[.]/, ","));
      $('#ywcnp_suggest_price_single').attr('value', parse_price);
    } // carrers filter


    var filterActive;

    function filterCategory(category) {
      if (filterActive !== category) {
        $('.filter-cat-results .filter-carrers').removeClass('active');
        $('.filter-cat-results .filter-carrers').filter('[data="' + category + '"]').addClass('active');

        if ($('.filter-cat-results .filter-carrers[data="' + category + '"]').length === 0) {
          $('.filter-cat-results .no-exist').addClass('active');
        }

        filterActive = category;
      }
    }

    $('.filter-carrers').addClass('active');
    $('.filtering select').change(function () {
      if ($(this).val() === 'cat-all') {
        $('.filter-cat-results .filter-carrers').addClass('active');
        $('.filter-cat-results .no-exist').removeClass('active');
        filterActive = 'cat-all';
      } else {
        filterCategory($(this).val());
      }
    });
  });
  body.on('change', '#packages-select', function (e) {
    e.preventDefault();
    window.location = $('option:selected', this).attr('data-link');
  });
  body.on('click', '#load-more-packages', function (e) {
    e.preventDefault();
    load_more_posts($(this));
  });

  function load_more_posts(button) {
    var dataLink = $('#post-loader-data');
    var container_ID = $('#' + dataLink.attr('data-container'));
    var post_type = dataLink.attr('data-post-type');
    var post_parent = dataLink.attr('data-post-parent');
    var taxonomy = dataLink.attr('data-taxonomy');
    var terms = dataLink.attr('data-terms');
    var lang_code = dataLink.attr('data-lang-code');
    var posts_per_page = parseInt(dataLink.attr('data-posts-per-page')) > 0 ? parseInt(dataLink.attr('data-posts-per-page')) : 6;
    var posts_offset = parseInt(dataLink.attr('data-offset'));
    var posts_total = parseInt(dataLink.attr('data-total'));
    var loader = button.find('.more-loader');
    var loader_content = button.find('.load-content');
    loader.toggle();
    loader_content.toggle();
    var formData = {
      'action': 'load_more_custom_posts',
      'post_type': post_type,
      'terms': terms,
      'taxonomy': taxonomy,
      'posts_per_page': posts_per_page,
      'post_parent': post_parent,
      'offset': posts_offset,
      'lang_code': lang_code
    };
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: formData,
      success: function success(data) {
        container_ID.append(data.posts_html);
        posts_offset = parseInt(posts_offset + posts_per_page);
        dataLink.attr('data-offset', posts_offset);

        if (posts_offset >= posts_total) {
          $('.load-more-posts-button').remove();
        }

        $(".lazy-load").each(function () {
          changeLazyLoadImage($(this));
          $(this).find('.lazy-blury').addClass('removed');
        });
        loader.toggle();
        loader_content.toggle();
      }
    });
  }

  var euro_symbol = '€';
  body.on('click', '.quantity-change', function (e) {
    e.preventDefault();
    var element = $(this);
    var data_element = $(this).parent();
    var key = data_element.attr('data-key');
    var variation_id = data_element.attr('data-variation');
    var price = data_element.attr('data-price');
    var quantity_input = data_element.find('.quantity-items');
    var quantity = parseInt(quantity_input.val());
    var reduce_quantity = element.hasClass('quantity-remove');

    if (quantity > 1 && reduce_quantity) {
      quantity -= 1;
    } else if (!reduce_quantity) {
      quantity += 1;
    }

    quantity_input.val(quantity);
    set_cart_quantity(key, quantity, variation_id);
    var row = element.closest('.separate-product');
    var total_price_html = row.find('.products-total__price');
    var total_price = parseFloat(quantity * price).toFixed(2);
    total_price_html.html(euro_symbol + ' ' + total_price);
  });
  body.on('change', '.quantity-items', function (e) {
    var element = $(this);
    var data_element = $(this).closest('.quantity');
    var key = data_element.attr('data-key');
    var variation_id = data_element.attr('data-variation');
    var price = data_element.attr('data-price');
    var quantity = $(this).val();

    if (quantity > 0) {
      set_cart_quantity(key, quantity, variation_id);
      var row = element.closest('.separate-product');
      var total_price_html = row.find('.products-total__price');
      var total_price = parseFloat(quantity * price).toFixed(2);
      total_price_html.html(euro_symbol + ' ' + total_price);
    }
  });

  function set_cart_quantity() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'set_cart_quantity',
        key: key,
        quantity: quantity
      },
      success: function success(data) {
        manage_header_cart_quantity(data.products_in_cart);
      }
    });
  }

  body.on('click', '.confirm-add-to-cart', function (e) {
    e.preventDefault();
    var this_block = $(this).closest('.buy-product');
    this_block.addClass('adding-cart');
    var product_id = this_block.find('input[name="product_id"]').val();
    var product_name = this_block.find('input[name="product_name"]').val();
    var variation_id = this_block.find('input[name="variation_id"]').val();
    var quantity = this_block.find('input[name="quantity"]').lenght ? this_block.find('input[name="quantity"]').lenght.val() : 1;
    var price = parseFloat($('.gift-card-price').html());
    var gcd_product_id = 0;
    var gcd_variation_id = 0;
    var button = $(this);
    var gift_card_text = $('.gift-card-content-textarea').val();

    if ($('#ywcnp_suggest_price_single').length && $('.gift-cards').length) {
      var selected_gift_card_design = $('.gift-card-design.selected');
      gcd_product_id = selected_gift_card_design.attr('data-product-id');
      gcd_variation_id = selected_gift_card_design.attr('data-variation-id');
    }

    manage_button_loader(button);
    add_to_cart(button, product_name, product_id, quantity, variation_id, price, gcd_product_id, gcd_variation_id, gift_card_text);
  });

  function add_to_cart(button, product_name, product_id, quantity, variation_id, price, gcd_product_id, gcd_variation_id, gift_card_text) {
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'add_to_cart',
        product_id: product_id,
        quantity: quantity,
        variation_id: variation_id,
        price: price,
        gcd_product_id: gcd_product_id,
        gcd_variation_id: gcd_variation_id,
        gift_card_text: gift_card_text
      },
      success: function success(results) {
        var key = results.cart_key;
        var popup = $('#popup-added-to-cart');
        var quantity_data = popup.find('.quantity');
        quantity_data.attr('data-key', key);
        quantity_data.attr('data-variation', variation_id);
        popup.show();
        $('body').addClass('modal-open');
        manage_header_cart_quantity(results.products_in_cart);
        $('.page-content__text.product-name').html(product_name);
        manage_button_loader(button);
      }
    });
  }

  function manage_button_loader(button) {
    var loader_container = button.parent();
    var loader = loader_container.find('.loader');
    button.toggleClass('hidden');
    loader.toggle();
  }

  function manage_header_cart_quantity(quantity) {
    var counter_html = $('.header-menu__basket--counter');
    counter_html.html(quantity);
    quantity > 0 ? counter_html.show() : counter_html.hide();
  }

  body.on('click', '.js-remove-product-from-cart', function (e) {
    e.preventDefault();
    var button = $(this);
    var product_id = button.attr('data-product');
    var price = button.attr('data-price');
    var variation_id = button.attr('data-variation');
    var cart_key = button.attr('data-cart-key');
    button.find('.products-info__delete.product').hide();
    button.find('.delete-loader').show();
    remove_from_cart(product_id, variation_id, cart_key, price, button);
  });

  function remove_from_cart(product_id, variation_id, cart_item_key, price, button) {
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'remove_from_cart',
        product_id: product_id,
        variation_id: variation_id,
        cart_item_key: cart_item_key,
        price: price
      },
      success: function success(results) {
        if (results.removed) {
          manage_header_cart_quantity(results.products_in_cart);
          button.closest('.separate-product').remove();

          if (results.products_in_cart === 0) {
            $('.shopping .products').hide();
            $('.cart').hide();
            $('.empty-cart-message').show();
          }
        }
      }
    });
  }

  body.on('click', '.shopping-radio-button-block input[name="person"]', function () {
    var elementVal = $(this).val(); //$('.shopping-input-group input').removeClass('required')
    //$('.shopping-input-group[data-'+elementVal+'="1"] input').addClass('required')
  });
  body.on('click', '.paysera-payment-method', function (e) {
    $('.paysera-payment-method').removeClass('error');
  });
  body.on('click', '.js-shop-next-tab', function (e) {
    e.preventDefault();
    var tab = parseInt($(this).attr('data-shop-next-tab'));
    var error = false;
    $('.shopping-input-group').removeClass('error');
    $('.form-error-message').hide();

    if (tab === 2) {
      //validate form
      $('.input-group__input.required:visible').each(function (e) {
        if ($(this).val().length === 0) {
          error = true;
          $(this).closest('.shopping-input-group').addClass('error');
          $('.form-error-message').show();
        }

        if ($(this).attr('name') === 'billing_email') {
          if (!isValidEmail($(this).val())) {
            error = true;
            $(this).closest('.shopping-input-group').addClass('error');
            $('.form-error-message').show();
          }
        }

        if ($(this).attr('name') === 'billing_phone') {
          if (!isValidPhone($(this).val())) {
            error = true;
            $(this).closest('.shopping-input-group').addClass('error');
            $('.form-error-message').show();
          }
        }

        $('.checkout-data-input').each(function () {
          var input = $(this);
          var value = input.val();
          var name = input.attr('name');
          var targetField = $('[data-billing="' + name + '"]');
          targetField.html(value);
        });
      });
    }

    if (tab === 3) {
      $('.payment-logo .form-checkbox__checkbox').removeClass('error');
      var checked_element = $('.activePayseraPayment');
      var bank_has_selected = checked_element.length;

      if (!bank_has_selected && $('.payment_method_paysera').length) {
        $('.paysera-payments .paysera-payment-method').addClass('error');
        error = true;
      }

      var selectedPaymentImageSrc = $('.activePayseraPayment .paysera-image img').attr('src');
      $('.payment-method-preview').attr('src', selectedPaymentImageSrc);
      var paymentTerms = $('#paymentCheckbox1');
      paymentTerms.removeClass('error');

      if (paymentTerms.length && !paymentTerms.is(':checked')) {
        paymentTerms.addClass('error');
        error = true;
      }
    }

    if (error) {
      return false;
    }

    $('.products-menu__item').removeClass('current');
    $('.js-shop-tabs').hide();
    $('.js-shop-tab-' + tab).show();
    $('[data-shop-header-tab="' + tab + '"]').addClass('current');
  });

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  if ($('.billing-details').length) {
    $('.shopping-input-group[data-private="0"]').hide();
    body.on('click', '.shopping-radio-button-block input[type="radio"]', function (e) {
      var radio = $(this);
      var value = radio.val();
      $('.shopping-input-group').hide();

      if (value === 'legal') {
        $('.shopping-input-group[data-legal="1"]').show();
      } else {
        $('#billing_company_registration_number').val('');
        $('#billing_company_vat_number').val('');
        $('.shopping-input-group[data-private="1"]').show();
      }
    });
  }

  $('.js-close-popup').click(function (event) {
    event.preventDefault();
    $(this).closest('.popup').fadeOut();
    $('body').removeClass('modal-open');
  });
  body.on('click', '.js-submit-subscribe', function (e) {
    e.preventDefault();
    var button = $(this);
    var email = button.parent().find('.subscribe-input').val();
    var email_error_message = button.attr('data-error-not-email');
    var error_message_field = button.parent().find('.error-message');
    error_message_field.html('');

    if (!isValidEmail(email)) {
      error_message_field.html(email_error_message);
      return false;
    }

    $("#subscribe-newsletter").submit();
  });
  $("#subscribe-newsletter").on('submit', function (e) {
    var formData = new FormData($(this)[0]);
    var button = $(this);
    var email_exists_message = button.find('.js-submit-subscribe').attr('data-error-exists');
    var error_message_field = button.find('.error-message');
    error_message_field.html('');
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: formData,
      async: false,
      cache: false,
      contentType: false,
      enctype: 'multipart/form-data',
      processData: false,
      success: function success(response) {
        if (response.success === 1) {
          $('#popup-subscribtion').show();
        } else {
          error_message_field.html(email_exists_message);
        }
      }
    });
    return false;
  });

  function isValidEmail(value) {
    var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(value).search(filter) !== -1;
  }

  function isValidPhone(value) {
    var cleanNumber = value.replace("+", "");
    cleanNumber = cleanNumber.replace(" ", "");
    cleanNumber = cleanNumber.replace(" ", "");
    cleanNumber = cleanNumber.replace(" ", "");
    cleanNumber = cleanNumber.replace(" ", "");
    cleanNumber = cleanNumber.replace("(", "");
    cleanNumber = cleanNumber.replace(")", "");
    cleanNumber = cleanNumber.replace("-", "");
    var filter = /^\d{8,15}$/gm;
    return filter.test(cleanNumber.trim());
  } // --------- Lazy load -------------


  var imgSize = 'data-img-src';

  if ($(window).width() <= 600) {
    imgSize = 'data-img-small';
  } else if ($(window).width() <= 1024) {
    imgSize = 'data-img-medium';
  }

  function changeLazyLoadImage(elem) {
    var imgSrc = elem.attr(imgSize);
    var nodname = elem[0]['nodeName'];

    if (!imgSrc) {
      imgSrc = elem.attr('data-img-src');
    }

    if (nodname != 'IMG') {
      elem.css('background', 'url(' + imgSrc + ') no-repeat center');
      elem.css('background-size', 'cover');
    } else {
      elem.attr('src', imgSrc);
    }
  } // -------- End lazy load ------------------------


  var input = $('.upload-input'); // let infoArea = document.getElementById('file-upload-filename')

  if (input != undefined) {
    input.on('change', function (e) {
      showFileName(this, event);
    });
  }

  function showFileName(element, event) {
    var input = event.srcElement;
    var fileName = input.files[0].name;
    $(element).parent().find('.file-upload-filename').html(fileName); // infoArea.textContent = fileName
  }
  /* Russian (UTF-8) initialisation for the jQuery UI date picker plugin. */

  /* Written by Andrew Stromnov (stromnov@gmail.com). */


  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["../widgets/datepicker"], factory);
    } else {
      // Browser globals
      factory(jQuery.datepicker);
    }
  })(function (datepicker) {
    datepicker.regional.ru = {
      closeText: "Закрыть",
      prevText: "&#x3C;Пред",
      nextText: "След&#x3E;",
      currentText: "Сегодня",
      monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
      monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
      dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
      dayNamesShort: ["вск", "пнд", "втр", "срд", "чтв", "птн", "сбт"],
      dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      weekHeader: "Нед",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ""
    };
    datepicker.setDefaults(datepicker.regional.ru);
    return datepicker.regional.ru;
  });
  /* Latvian (UTF-8) initialisation for the jQuery UI date picker plugin. */

  /* @author Arturas Paleicikas <arturas.paleicikas@metasite.net> */


  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["../widgets/datepicker"], factory);
    } else {
      // Browser globals
      factory(jQuery.datepicker);
    }
  })(function (datepicker) {
    datepicker.regional.lv = {
      closeText: "Aizvērt",
      prevText: "Iepr.",
      nextText: "Nāk.",
      currentText: "Šodien",
      monthNames: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"],
      dayNames: ["svētdiena", "pirmdiena", "otrdiena", "trešdiena", "ceturtdiena", "piektdiena", "sestdiena"],
      dayNamesShort: ["svt", "prm", "otr", "tre", "ctr", "pkt", "sst"],
      dayNamesMin: ["Sv", "Pr", "Ot", "Tr", "Ct", "Pk", "Ss"],
      weekHeader: "Ned.",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ""
    };
    datepicker.setDefaults(datepicker.regional.lv);
    return datepicker.regional.lv;
  });
  /* English/UK initialisation for the jQuery UI date picker plugin. */

  /* Written by Stuart. */


  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["../widgets/datepicker"], factory);
    } else {
      // Browser globals
      factory(jQuery.datepicker);
    }
  })(function (datepicker) {
    datepicker.regional["en-GB"] = {
      closeText: "Done",
      prevText: "Prev",
      nextText: "Next",
      currentText: "Today",
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      weekHeader: "Wk",
      dateFormat: "dd/mm/yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ""
    };
    datepicker.setDefaults(datepicker.regional["en-GB"]);
    return datepicker.regional["en-GB"];
  });

  var site_lang = $('html').attr('lang');

  if (site_lang === 'ru' || site_lang === 'lv') {
    $.datepicker.setDefaults($.datepicker.regional[site_lang]);
  } else {
    $.datepicker.setDefaults($.datepicker.regional['en-GB']);
  }
  /* Avail pro form */


  var datePicker = $('#datepicker, #rooms-checkin-datepicker, #form-datepicker');
  datePicker.datepicker({
    defaultDate: "+0",
    changeMonth: true,
    dateFormat: 'dd M, yy',
    firstDay: 1,
    minDate: "+0",
    // Disable datepicker if readonly attribute is present
    beforeShow: function beforeShow(i) {
      return !$(i).attr('readonly');
    },
    onSelect: function onSelect(dateText, inst) {
      var d = $.datepicker.parseDate(inst.settings.dateFormat, dateText); //d.setDate(d.getDate() + 1);
      //$("#rooms-checkout-datepicker").val($.datepicker.formatDate(inst.settings.dateFormat, d));
      //$("#second-datepicker").val($.datepicker.formatDate(inst.settings.dateFormat, d));

      var currentYear = inst.currentYear;
      var currentMonth = parseInt(inst.currentMonth);
      var currentDay = inst.currentDay;
      var year_month = currentYear + '-' + (currentMonth + 1);
      var day_option_html = '<option value="' + currentDay + '" selected></option>';
      var year_month_html = '<option value="' + year_month + '" selected></option>';

      if ($(this).hasClass('select-checkin-date')) {
        $('#AVP_list_months').find('option[value="' + year_month + '"]').prop('selected', true).trigger('change');
        setDays();
        $('#AVP_list_days').find('option[value="' + currentDay + '"]').prop('selected', true).trigger('change'); //$('#AVP_list_days').html(day_option_html);
        //$('#AVP_list_months').html(year_month_html); // $('#AVP_list_days').find('option[value="'+currentDay+'"]').prop('selected', true)
        // $('#AVP_list_months').find('option[value="'+year_month+'"]').prop('selected', true)
        //sec_date.setDate(d.getDate() + 1)
        //sec_date.datepicker('setDate', d.getDate() + 1);
        //var date2 = d.datepicker('getDate', '+1d');

        d.setDate(d.getDate() + 1);
        sec_date.datepicker('setDate', d);
        currentYear = d.getFullYear();
        currentMonth = parseInt(d.getMonth());
        currentDay = d.getDate();
        year_month = currentYear + '-' + (currentMonth + 1);
        day_option_html = '<option value="' + currentDay + '" selected></option>';
        year_month_html = '<option value="' + year_month + '" selected></option>'; //$('#AVP_list_ddays').html(day_option_html);
        //$('#AVP_list_dmonths').html(year_month_html);

        $('#AVP_list_dmonths').find('option[value="' + year_month + '"]').prop('selected', true).trigger('change');
        setDDays();
        $('#AVP_list_ddays').find('option[value="' + currentDay + '"]').prop('selected', true).trigger('change');
      } else if ($(this).hasClass('select-checkout-date')) {
        $('#AVP_list_dmonths').find('option[value="' + year_month + '"]').prop('selected', true).trigger('change');
        setDays();
        $('#AVP_list_ddays').find('option[value="' + currentDay + '"]').prop('selected', true).trigger('change'); //$('#AVP_list_ddays').html(day_option_html);
        //$('#AVP_list_dmonths').html(year_month_html); // $('#AVP_list_ddays').find('option[value="'+currentDay+'"]').prop('selected', true)
        // $('#AVP_list_dmonths').find('option[value="'+year_month+'"]').prop('selected', true)
      }
    },
    onClose: function onClose(selectedDate) {
      $("#rooms-checkout-datepicker").datepicker("option", "minDate", selectedDate);
      $("#second-datepicker").datepicker("option", "minDate", selectedDate);
    }
  });
  datePicker.datepicker('setDate', new Date());
  var second_date_pircker = $('#second-datepicker, #rooms-checkout-datepicker');
  var sec_date = second_date_pircker.datepicker({
    defaultDate: "+0",
    changeMonth: true,
    dateFormat: 'dd M, yy',
    firstDay: 1,
    minDate: "+1",
    // Disable datepicker if readonly attribute is present
    beforeShow: function beforeShow(i) {
      return !$(i).attr('readonly');
    },
    onSelect: function onSelect(dateText, inst) {
      var d = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
      d.setDate(d.getDate() + 1); //$("#rooms-checkout-datepicker").val($.datepicker.formatDate(inst.settings.dateFormat, d));

      var currentYear = inst.currentYear;
      var currentMonth = parseInt(inst.currentMonth);
      var currentDay = inst.currentDay;
      var year_month = currentYear + '-' + (currentMonth + 1);
      var day_option_html = '<option value="' + currentDay + '" selected></option>';
      var year_month_html = '<option value="' + year_month + '" selected></option>';

      if ($(this).hasClass('select-checkin-date')) {
        $('#AVP_list_days').html(day_option_html);
        $('#AVP_list_months').html(year_month_html); // $('#AVP_list_days').find('option[value="'+currentDay+'"]').prop('selected', true)
        // $('#AVP_list_months').find('option[value="'+year_month+'"]').prop('selected', true)
      } else if ($(this).hasClass('select-checkout-date')) {
        $('#AVP_list_ddays').find('option[value="' + currentDay + '"]').prop('selected', true).trigger('change');
        $('#AVP_list_dmonths').find('option[value="' + year_month + '"]').prop('selected', true).trigger('change'); //$('#AVP_list_ddays').html(day_option_html);
        //$('#AVP_list_dmonths').html(year_month_html); // $('#AVP_list_ddays').find('option[value="'+currentDay+'"]').prop('selected', true)
        // $('#AVP_list_dmonths').find('option[value="'+year_month+'"]').prop('selected', true)
      }
    },
    onClose: function onClose(selectedDate) {//second_date_pircker.datepicker("option", "minDate", selectedDate);
    }
  });
  second_date_pircker.datepicker('setDate', new Date());
  body.on('change', '.select-persons-number', function (e) {
    var elem = $(this);
    var id_target = elem.attr('data-js-target');
    var value_html = '<option value="' + elem.val() + '" selected></option>';
    $('#' + id_target).html(value_html);
    e.preventDefault();
  });
  body.on('click', '.find-rooms', function (e) {
    e.preventDefault();
    $("#avp-validate-rooms").click();
  });
  /* EOF Avail pro form */

  body.on('click', '#floor-plan path[data-conference]', function (e) {
    e.preventDefault();
    var elem_id = $(this).attr('data-conference');
    var row = $('div[data-conference="' + elem_id + '"]');
    row.toggleClass('show, conference-description-toggle');
    row.find('.conference-description').toggleClass("toggle-border");
    row.find('.conference-description-responsive-open').slideToggle().toggleClass('visible');
    row.next('.conference-description__open').slideToggle().toggleClass('visible');
    row.find('.open-conference-img').toggle();
    initializeConferenceSlider($('.conference-blocks[data-conference="' + elem_id + '"]').parent().find('.main-slider'));
    $("html, body").animate({
      scrollTop: row.offset().top - 150
    }, 1000);
  });

  function initializeConferenceSlider(slider) {
    // current slide
    var $mainSlider = slider;
    var sliderParent = $mainSlider.closest('.conference-description__block');
    var $progressBar = sliderParent.find('.progress');
    var $progressBarLabel = sliderParent.find('.slider__label');
    var $currentSlide = sliderParent.find('.current-slide');
    var $allSlides = sliderParent.find('.all-slides');
    $mainSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
      var i = (currentSlide || 0) + 1;
      $currentSlide.text(i);
    }); // total slides

    $mainSlider.on('init reInit afterChange', function (event, slick) {
      $allSlides.text(slick.slideCount);
    });
    $mainSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
      var current = (currentSlide || 0) + 1;
      var calc = current / slick.slideCount * 100;
      $progressBar.css('background-size', calc + '% 100%');
    });
    $mainSlider.slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: $('.prev'),
      nextArrow: $('.next')
    });
  }

  var js_request_proposal_modal = $('#js-request-proposal');
  body.on('click', '.js-request-proposal', function (e) {
    e.preventDefault();
    var contact_form_id = $(this).attr('data-contact-id');
    var cf_pid = $(this).attr('data-cfpid');
    var additional_info = $(this).attr('data-additional-info');
    js_request_proposal_modal.find('.text-popup').html('<div class="lds-ripple"><div></div><div></div></div>');
    js_request_proposal_modal.show();
    $.ajax({
      url: ajaxurl,
      type: 'GET',
      data: {
        action: 'load_contact_form_html',
        contact_form_id: contact_form_id,
        cf_pid: cf_pid
      },
      success: function success(results) {
        js_request_proposal_modal.find('.text-popup').html(results.html);
        $('input[name="additional-info"]').val(additional_info);
        var datePicker = $('.hasDatepickerCalendar');
        datePicker.datepicker({
          defaultDate: "+0",
          changeMonth: true,
          dateFormat: 'dd M, yy',
          firstDay: 1,
          minDate: "+0",
          // Disable datepicker if readonly attribute is present
          beforeShow: function beforeShow(i) {
            return !$(i).attr('readonly');
          },
          onSelect: function onSelect(dateText, inst) {
            var d = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
            d.setDate(d.getDate() + 1);
            console.log('date:' + d);
          },
          onClose: function onClose(selectedDate) {}
        });
        datePicker.datepicker('setDate', new Date());
        $('.js-custom-form').each(function () {
          var names = "";
          $('[id^="field-"]').each(function () {
            names += $(this).attr('name') + " ";
          });
          names = $.trim(names);
          $(this).validate({
            // errorContainer: '.main-form-errors',
            // errorLabelContainer: '.main-form-errors ul',
            errorContainer: $(this).find('.main-form-errors'),
            errorLabelContainer: $('ul', $(this).find('.main-form-errors')),
            wrapper: 'li',
            ignore: [],
            groups: {
              mygroup: names
            },
            submitHandler: function submitHandler(form) {
              js_request_proposal_modal.hide();
              var success_title = $(this).data('success-title');
              var $success_popup = $('#form-success');
              $success_popup.find('.success-message').html(success_title);
              var formData = new FormData($(form)[0]);
              var gaCategory = $(form).find('input[name="analyitics-category"]');
              var gaLabel = $(form).find('input[name="analyitics-label"]');
              $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: formData,
                async: false,
                cache: false,
                contentType: false,
                enctype: 'multipart/form-data',
                processData: false,
                success: function success(response) {
                  $('.js-custom-form').trigger('reset');

                  if (response.ok == 1) {
                    $success_popup.css('display', 'block');
                    $('body').addClass('modal-open');

                    if (gaCategory.length && gaLabel.length) {
                      gaCategory = gaCategory.val();
                      gaLabel = gaLabel.val();
                      gtag('event', 'click', {
                        'event_category': gaCategory,
                        'event_label': gaLabel
                      });
                    }
                  }
                }
              });
              return false;
            }
          });
        });
      }
    });
  });
  body.on('click', '.search-bar__form img', function (e) {
    $(this).parent().submit();
  });
  $('table').wrap('<div class="table-wrapper">', '</div>');
  body.on('change', '.form-radio-group .form-checkbox__checkbox', function (e) {
    var value_input = $(this).closest('.form-radio-group').find('.checkbox-list-value');
    var new_value = '';
    $(this).closest('.form-radio-group').find('.form-checkbox__checkbox').each(function (e) {
      if ($(this).is(':checked')) {
        new_value += $(this).val() + ', ';
      }
    });
    value_input.val(new_value.slice(0, -2));
  });
  $(function () {
    var has_terms_accepted = $.cookie('cookies_accepted');

    if (has_terms_accepted !== '1') {
      $('#cookies').fadeIn();
    } // $( ".lazy-load" ).each(function() {
    //   $(this).find('.lazy-blury').addClass('removed')
    //   changeLazyLoadImage($(this));
    //   console.log('here')
    // });


    $(".js-responsive-img").each(function () {
      changeLazyLoadImage($(this));
    }); //-----------   popups ---------------------------------

    var firstTime = getCookie('firstTime');

    if (firstTime == "") {
      setCookie('firstTime', 'false', 90);
    }

    if (input != undefined) {}

    popupSettings.forEach(function (element, i) {
      var show = 1;

      if (popupSettings[i]['type'] == 'first' && firstTime == "false") {
        show = 0;
      }

      if (popupSettings[i]['type'] == 'been' && firstTime == "") {
        show = 0;
      }

      if (popupSettings[i]['frequency']) {
        var lastSeenPopup = getCookie('lastSeenPopup' + popupSettings[i]['id']);

        if (lastSeenPopup == "") {
          lastSeenPopup = 0;
        }

        var nextShowingTime = parseInt(lastSeenPopup) + parseInt(popupSettings[i]['frequency']) * 60;

        if (timeNow < nextShowingTime) {
          show = 0;
        } else {
          setCookie('lastSeenPopup' + popupSettings[i]['id'], timeNow, 90);
        }
      }

      if (show == 1) {
        $('#popup-' + popupSettings[i]['id']).fadeIn();
      }
    }); // ---------- End popups -------------------------------
  });
  /*IE payment checkout*/

  body.on('click', '.payment-group-wrapper .paysera-payment-method', function (e) {
    $('.activePayseraPayment').removeClass('activePayseraPayment');
    $(this).addClass('activePayseraPayment');
  }); // eslint-disable-next-line no-undef

  body.on('change', '#modal-promo-code, #header-promo-code', function (e) {
    e.preventDefault();
    $('#promoCode').val($(this).val());
  });

  if ($('.tribe-events-single').length) {
    var form_id = $('#tribe-events-pg-template').attr('data-contact-id');
    var form_button_text = $('#tribe-events-pg-template').attr('data-button-text');
    var additional_info_name = $('.tribe-events-schedule.tribe-clearfix').closest('.tribe-events-single').find('.tribe-events-single-event-title').html();
    var additional_info_datetime = $('.tribe-events-schedule.tribe-clearfix').closest('.tribe-events-single').find('.tribe-event-date-start').html();
    var additional_info = additional_info_name + ' | ' + additional_info_datetime;
    var button_html = '<button class="page-content__button js-request-proposal" data-contact-id="' + form_id + '" data-cfpid="" style="\n' + '    width: auto;\n' + '    float: right;\n' + '    padding: 19px;\n' + '" data-additional-info="' + additional_info + '">' + form_button_text + '</button>';
    $('.tribe-events-schedule.tribe-clearfix').append(button_html);
  }

  if ($(window).width() > 1340) {
    $('[data-block="zigzag-image-content"]').each(function () {
      var element = $(this);
      var image = element.find('.zig-zag-img');
      var blockContent = element.find('.block-content');
      var imageHeight = image.outerHeight();
      var blockContentHeight = blockContent.outerHeight();

      if (blockContentHeight > imageHeight) {
        element.css('height', blockContentHeight);
      }
    });
  }
});
window.addEventListener('load', function () {
  // $('.lazy-load').each(function () {
  //   console.log($(this).offset().top + ' - ' + $(this).attr('class'))
  // })
  // $('img').each(function () {
  //   console.log($(this).offset().top + ' - ' + $(this).attr('class'))
  // })
  $('.lazy-load').waypoint(function (direction) {
    var element = $(this.element);
    element.find('.lazy-blury').addClass('removed');
    changeLazyLoadImage(element);
  }, {
    //context: '.homepage',
    offset: '120%' //triggerOnce: true

  });
  $('img').waypoint(function (direction) {
    var element = $(this.element);
    var data_src = element.attr('data-src');
    element.attr('src', data_src);
  }, {
    //context: '.homepage',
    offset: '120%' //triggerOnce: true

  });
  var imgSize = 'data-img-src';

  if ($(window).width() <= 600) {
    imgSize = 'data-img-small';
  } else if ($(window).width() <= 1024) {
    imgSize = 'data-img-medium';
  }

  function changeLazyLoadImage(elem) {
    var imgSrc = elem.attr(imgSize);
    var nodname = elem[0]['nodeName'];

    if (!imgSrc) {
      imgSrc = elem.attr('data-img-src');
    }

    if (nodname != 'IMG') {
      elem.css('background', 'url(' + imgSrc + ') no-repeat center');
      elem.css('background-size', 'cover');
    } else {
      elem.attr('src', imgSrc);
    }
  }
}) + $(function () {
  'use strict'; // eslint-disable-next-line no-undef
}) + $(function () {
  'use strict'; //front slider

  var $mainSlider = $('.responsive-rooms .main-slider');
  var $progressBar = $('.responsive-rooms .progress');
  var $progressBarLabel = $('.responsive-rooms .slider__label');
  var $currentSlide = $('.responsive-rooms .current-slide');
  var $allSlides = $('.responsive-rooms .all-slides');
  var $prevArrow = $('.front-page-slider .prev');
  var $nextArrow = $('.front-page-slider .next'); //current slide

  $mainSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    var i = (currentSlide || 0) + 1;
    $currentSlide.text(i);
  }); // total slides

  $mainSlider.on('init reInit afterChange', function (event, slick) {
    $allSlides.text(slick.slideCount);
  });
  $mainSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    var current = (currentSlide || 0) + 1;
    var calc = current / slick.slideCount * 100;
    $progressBar.css('background-size', calc + '% 100%');
  });
  $mainSlider.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 2000,
    pauseOnHover: false,
    prevArrow: $prevArrow,
    nextArrow: $nextArrow
  }); //eof front slider

  $(function () {
    // awards slider
    var $awardsSlider = $('.awards-slider');
    var $awardsProgressBar = $('.awards-progress');
    var $awardsAllSlides = $('.awards-all__slides');
    var $awardsCurrentSlide = $('.awards-current__slide');
    $awardsSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
      var i = (currentSlide || 0) + 1;
      $awardsCurrentSlide.text(i);
    });
    $awardsSlider.on('init reInit afterChange', function (event, slick) {
      $awardsAllSlides.text(slick.slideCount);
    });
    $awardsSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
      var current = (currentSlide || 0) + 1;
      var calc = current / slick.slideCount * 100;
      $awardsProgressBar.css('background-size', calc + '% 100%');
    });
    $awardsSlider.slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 3000,
      prevArrow: $('.awards-prev'),
      nextArrow: $('.awards-next')
    }); //eof awards slider
    //gallery block slider

    var $gallerySlider = $('.gallery-block-slider');
    var $galleryProgressBar = $('.gallery-slider-block .progress');
    var $galleryProgressBarLabel = $('.gallery-slider-block .slider__label');
    var $galleryCurrentSlide = $('.gallery-slider-block .current-slide');
    var $galleryAllSlides = $('.gallery-slider-block .all-slides');

    if ($gallerySlider.length) {
      //current slide
      $gallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
        var i = (currentSlide || 0) + 1;
        $galleryCurrentSlide.text(i);
      }); // total slides

      $gallerySlider.on('init reInit afterChange', function (event, slick) {
        $galleryAllSlides.text(slick.slideCount);
      });
      $gallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
        var current = (currentSlide || 0) + 1;
        var calc = current / slick.slideCount * 100;
        $galleryProgressBar.css('background-size', calc + '% 100%');
      });
      $gallerySlider.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev'),
        nextArrow: $('.next')
      }); //eof gallery block slider
    }

    $('.room-slider').owlCarousel({
      stagePadding: 20,
      smartSpeed: 1000,
      lazyLoad: true,
      nav: true,
      dots: false,
      navText: ['', ''],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2,
          stagePadding: 42
        },
        1340: {
          items: 2,
          stagePadding: 115
        },
        1440: {
          items: 3,
          stagePadding: 115
        }
      }
    });
    $('.packages-slider').owlCarousel({
      stagePadding: 20,
      smartSpeed: 1000,
      lazyLoad: true,
      nav: true,
      dots: false,
      navText: ['', ''],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2,
          stagePadding: 56
        },
        1340: {
          items: 2,
          stagePadding: 115
        },
        1440: {
          items: 3,
          stagePadding: 115
        }
      }
    });
    $('.news-slider').owlCarousel({
      stagePadding: 20,
      smartSpeed: 1000,
      //lazyLoad:true,
      nav: true,
      dots: false,
      navText: ['', ''],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2,
          stagePadding: 42
        },
        1340: {
          items: 2,
          stagePadding: 115
        },
        1440: {
          items: 3,
          stagePadding: 115
        }
      }
    });
    var videoSlider = $('#video-slider').owlCarousel({
      items: 1,
      video: true,
      smartSpeed: 500
    });
    videoSlider.on('change.owl.carousel', function (event) {
      var currentVideoIndex = event.relatedTarget.current();
      var previousVideoIndex = event.item.index;
      console.log(currentVideoIndex); //$('#video-slider iframe').attr('src', '')

      var active_slide = $('.video-src-' + previousVideoIndex);
      var addSrc = active_slide.attr('data-src');
      active_slide.attr('src', addSrc);
    });
    $('.owl-video-play-icon').remove();
    $('.owl-video-tn').remove();
  });
}) + $(function () {
  $('body').on('click', '#accept-cookies', function (e) {
    e.preventDefault();
    $.cookie('cookies_accepted', 1, {
      expires: 30,
      path: '/'
    });
    $(this).parent().fadeOut();
  });
}) + $(function (e) {
  $('body').on('change', '.upload-input', function () {
    console.log();
    var element = $(this);
    var container = element.parent();
    var label = container.find('label');
    var filename = this.files ? this.files[0].name : label.attr('data-default-text');
    var error_field = container.find('.error-field');
    var extArr = ['pdf', 'docx', 'doc'];
    var error_msg = '';
    var has_error = false; //validate file type

    var ext = this.files[0].name.split('.').pop().toLowerCase();

    if ($.inArray(ext, extArr) == -1) {
      error_msg = error_field.attr('data-type-not-allowed');
      has_error = true;
    }

    if (has_error) {
      error_field.html(error_msg);
      return false;
    }

    label.html(filename);
  });
});
$(function () {
  console.log('restaurant js');
  var restaurantClosedDate = $('#restaurant-time-limit-date').val();
  var restaurantClosedStartTime = $('#restaurant-time-limit-start').val();
  var restaurantClosedEndTime = $('#restaurant-time-limit-end').val();
  console.log(restaurantClosedDate);
  console.log(restaurantClosedStartTime);
  console.log(restaurantClosedEndTime);
  var restaurantDatePicker = $('.restaurant-hasDatepickerCalendar');
  restaurantDatePicker.datepicker({
    defaultDate: "+0",
    changeMonth: true,
    dateFormat: 'dd M, yy',
    firstDay: 1,
    minDate: "+0",
    // Disable datepicker if readonly attribute is present
    beforeShow: function beforeShow(i) {
      console.log('here');
      return !$(i).attr('readonly');
    },
    onSelect: function onSelect(dateText, inst) {
      var d = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
      var formattedDate = formatted_datetime(dateText);
      updateSelectTimes(formattedDate);
    },
    onClose: function onClose(selectedDate) {
      console.log('close');
    }
  });
  restaurantDatePicker.datepicker('setDate', new Date());
});

function updateSelectTimes(formattedDate) {
  var restaurantClosedDate = $('#restaurant-time-limit-date').val();
  var restaurantClosedStartTime = $('#restaurant-time-limit-start').val();
  var restaurantClosedEndTime = $('#restaurant-time-limit-end').val();
  var select = $('.type-select-restaurant');

  if (!restaurantClosedDate || !restaurantClosedStartTime || !restaurantClosedEndTime) {
    return false;
  }

  var options = select.length ? select.find('option') : null;

  if (options) {
    console.log('update: ' + formattedDate + ' -- ' + restaurantClosedDate);

    if (formattedDate === restaurantClosedDate) {
      var start = new Date(restaurantClosedDate + ' ' + restaurantClosedStartTime);
      var end = new Date(restaurantClosedDate + ' ' + restaurantClosedEndTime);
      options.each(function (k, v) {
        var optionTime = $(this).val();

        if (optionTime !== 0) {
          var optionFormatTime = new Date(restaurantClosedDate + ' ' + optionTime);

          if (optionFormatTime >= start && optionFormatTime <= end) {
            $(this).hide();
            console.log(optionFormatTime + ' - ' + start + ' - ' + end);
          }
        }
      });
    } else {
      options.each(function (k, v) {
        $(this).show();
      });
    }
  }
}

function formatted_datetime(datetime) {
  datetime = new Date(datetime);
  var year = datetime.getFullYear();
  var month = datetime.getMonth() + 1;
  var day = datetime.getDate();
  var hours = datetime.getHours();
  var minutes = datetime.getMinutes();
  var seconds = datetime.getSeconds();
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  return year + '-' + month + '-' + day;
}